
  const mySwiperProductGrid = new Swiper('.swiper-product-grid', {  
  loop: true,  
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',    
  },
});


document.addEventListener("DOMContentLoaded", function () {
  const productTypeEl = document.querySelector('#Product-Type');
  if (!productTypeEl) return;

  const productType = productTypeEl.dataset.productType;
  if (productType !== "オリジナルラベル") return;

  const quantityInput = document.querySelector('#Product-Quantity');
  const plusButton = document.querySelector('button[name="plus"]');
  const minusButton = document.querySelector('button[name="minus"]');

  const step = 49;
  const min = 50;

  if (plusButton && minusButton && quantityInput) {
    plusButton.addEventListener('click', (e) => {
      e.preventDefault();
      const current = parseInt(quantityInput.value) || min;
      quantityInput.value = current + step;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    minusButton.addEventListener('click', (e) => {
      e.preventDefault();
      const current = parseInt(quantityInput.value) || min;
      if (current > min) {
        quantityInput.value = current - step;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
});

//data-stepのstepを更新
document.addEventListener("DOMContentLoaded", () => {
  const jsInputStep = () => {
    document.querySelectorAll(".jsInputStep").forEach(el => {
      if (el.getAttribute("data-step") !== el.getAttribute("step")) {
        el.setAttribute("step", el.getAttribute("data-step"));
      }
    });
  };
  jsInputStep();
  const observerInput = new MutationObserver(() => jsInputStep());
  observerInput.observe(document.body, { childList: true, subtree: true });
});